






























































import Vue from 'vue';
import SideMenu from '@/components/util/SideMenu.vue';

interface IQAThumnail {
  caption: string;
  src: string;
  srcSP: string; // スマホ用
}

interface IQAItem {
  thumbnail: IQAThumnail[];
  subTitle: string;
  url: string;
}

interface IQAData {
  title: string;
  items: IQAItem[];
}

export default Vue.extend({
  name: 'HelpList',
    components: {
    SideMenu,
  },
  data() {
    return {
      uninstallHelpList: [
        {
          title: 'アンインストール手順',
          items: [
            {
              thumbnail: [
                {
                  caption: '１．Windowsの設定【プログラムの追加と削除】より「RemoLabo」と検索しアンインストールを選択します。',
                },
                {
                  caption: '２．アンインストール選択時に表示されるダイアログにて、クライアントツール画面のアンインストールパスワードを入力します。\n※アンインストール後にPCの再起動をお願いいたします。',
                  src: '/images/help/q07_01.png',
                  srcSP: '/images/help/q07_01_sp.png',
                },
              ],
              subTitle: 'クライアントツールの削除方法（Windows版）',
            },
            {
              thumbnail: [
                {
                  caption: '【Mojave_10.14】\n１．Finderを開き、「移動」メニューから「フォルダへ移動」を選択します。',
                  src: '/images/help/mac02/01.png',
                },
                {
                  caption: '２．「/ライブラリ」を入力して検索します。\n※先頭のスラッシュを忘れずに入力',
                  src: '/images/help/mac02/02.png',
                },
                {
                  caption: '３．ライブラリフォルダが表示されるので、右上の検索フォームに"RemoLaboUninstaller"と入力します。',
                  src: '/images/help/mac02/03.png',
                },
                {
                  caption: '４．「検索：」で「このMac」と「"ライブラリ"」が選択できるので、「"ライブラリ"」を選択します。しばらく待つと、RemoLaboUninstallerのアプリが表示されます。',
                  src: '/images/help/mac02/04.png',
                },
                {
                  caption: '５．RemoLaboUninstallerアプリのアイコンをダブルクリックすると、アンインストーラが起動します。以上で【Mojave_10.14】版のアンインストールが完了です。',
                  src: '/images/help/mac02/05.png',
                },
                {
                  caption: '\n\n【Catalina_10.15】\n１．右上の虫眼鏡アイコンをクリックします。',
                },
                {
                  caption: '２．Spotlight検索の入力フォームが表示されます。',
                  src: '/images/help/mac02/06.png',
                },
                {
                  caption: '３．"RemoLaboUninstaller" で検索すると、以下が表示されます。赤枠の行をダブルクリックすると、アンインストーラが起動します。',
                  src: '/images/help/mac02/07.png',
                },
                {
                  caption: '以上で【Catalina_10.15】版のアンインストールが完了です。',
                  src: '/images/help/mac02/08.png',
                },
              ],
              subTitle: 'クライアントツールの削除方法（Mac版）',
            },
          ],
        },
      ] as IQAData[],
      setModalData: {} as IQAItem,
      answerOpen: false,

    };
  },
  methods: {
    openModal(data: IQAItem) {
      window.scrollTo(0, 0);
      this.setModalData = data;
      this.answerOpen = true;
    },
  },
});
